import { AuthenticatedComponent } from 'app/shared/layout/authenticated/authenticated.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NonauthenticatedComponent } from './shared/layout/nonauthenticated/nonauthenticated.component';
import { AboutComponent } from './shared/layout/nonauthenticated/about/about.component';
import { AnnouncementsComponent } from './shared/layout/nonauthenticated/announcements/announcements.component';
import { FaqComponent } from './shared/layout/nonauthenticated/faq/faq.component';
import { FeaturesComponent } from './shared/layout/nonauthenticated/features/features.component';
import { PricingComponent } from './shared/layout/nonauthenticated/pricing/pricing.component';
import { EnterpiseComponent } from './shared/layout/nonauthenticated/enterpise/enterpise.component';
import { PartnersComponent } from './shared/layout/nonauthenticated/partners/partners.component';
import { ContactUsComponent } from './shared/layout/nonauthenticated/contact-us/contact-us.component';
import { LoginComponent } from './shared/layout/nonauthenticated/login/login.component';
import { NonAuthGuard } from './shared/guards/nonauth.guard';
import { RegisterComponent } from './shared/layout/nonauthenticated/register/register.component';
import { ForgotPasswordComponent } from './shared/layout/nonauthenticated/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './shared/layout/nonauthenticated/reset-password/reset-password.component';
import { UnsubsComponent } from './shared/layout/nonauthenticated/unsubs/unsubs.component';
import { RetrevaMinimalComponent } from './shared/layout/retreva-minimal/retreva-minimal.component';
import { HomeComponent } from './shared/layout/retreva-minimal/home/home.component';
import { AcceptPolicyComponent } from './dialogs/accept-policy/accept-policy.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { AdminGuard } from './shared/guards/admin.guard';
import { FranchiseAccessGuard } from './shared/guards/franchise-access.guard';
import { RegisterReferralComponent } from './shared/layout/nonauthenticated/register-referral/register-referral.component';
import {
  ReferralRegistrationThankYouComponent
} from './shared/layout/nonauthenticated/referral-registration-thank-you/referral-registration-thank-you.component';
import { SpacescoutCallbackComponent } from './shared/layout/nonauthenticated/spacescout-callback/spacescout-callback.component';

const routes: Routes = [
  {
    path: 'home',
    component: RetrevaMinimalComponent,
    children: [
      {
        path: '',
        canActivate: [NonAuthGuard],
        component: HomeComponent,
      },
    ],
  },
  {
    path: 'terms',
    component: RetrevaMinimalComponent,
    children: [
      {
        path: '',
        canActivate: [NonAuthGuard],
        component: AcceptPolicyComponent,
      },
    ],
  },
  {
    path: 'features',
    component: NonauthenticatedComponent,
    children: [
      {
        path: '',
        canActivate: [NonAuthGuard],
        component: FeaturesComponent,
      },
    ],
  },
  {
    path: 'pricing',
    component: NonauthenticatedComponent,
    children: [
      {
        path: '',
        canActivate: [NonAuthGuard],
        component: PricingComponent,
      },
    ],
  },
  {
    path: 'enterprise',
    component: NonauthenticatedComponent,
    children: [
      {
        path: '',
        canActivate: [NonAuthGuard],
        component: EnterpiseComponent,
      },
    ],
  },
  {
    path: 'partners',
    component: NonauthenticatedComponent,
    children: [
      {
        path: '',
        canActivate: [NonAuthGuard],
        component: PartnersComponent,
      },
    ],
  },
  {
    path: 'contact_us',
    component: NonauthenticatedComponent,
    children: [
      {
        path: '',
        // canActivate: [NonAuthGuard],
        component: ContactUsComponent,
      },
    ],
  },
  {
    path: 'about_us',
    component: NonauthenticatedComponent,
    children: [
      {
        path: '',
        // canActivate: [NonAuthGuard],
        component: AboutComponent,
      },
    ],
  },
  {
    path: 'faq',
    component: NonauthenticatedComponent,
    children: [
      {
        path: '',
        // canActivate: [NonAuthGuard],
        component: FaqComponent,
      },
    ],
  },
  {
    path: 'announcements',
    component: NonauthenticatedComponent,
    children: [
      {
        path: '',
        // canActivate: [NonAuthGuard],
        component: AnnouncementsComponent,
      },
    ],
  },
  {
    path: 'auth/spacescout/callback',
    component: RetrevaMinimalComponent,
    children: [
      {
        path: '',
        canActivate: [NonAuthGuard],
        component: SpacescoutCallbackComponent,
      },
    ],
  },
  {
    path: 'login',
    component: RetrevaMinimalComponent,
    children: [
      {
        path: '',
        canActivate: [NonAuthGuard],
        component: LoginComponent,
      },
    ],
  },
  {
    path: 'register',
    component: RetrevaMinimalComponent,
    children: [
      {
        path: '',
        canActivate: [NonAuthGuard],
        component: RegisterComponent,
      },
    ],
  },
  {
    path: 'forgot_password',
    component: RetrevaMinimalComponent,
    children: [
      {
        path: '',
        canActivate: [NonAuthGuard],
        component: ForgotPasswordComponent,
      },
    ],
  },
  {
    path: 'reset-password',
    component: RetrevaMinimalComponent,
    children: [
      {
        path: '',
        canActivate: [NonAuthGuard],
        component: ResetPasswordComponent,
      },
    ],
  },
  {
    path: 'register-referral',
    component: RetrevaMinimalComponent,
    children: [
      {
        path: 'thank-you',
        canActivate: [NonAuthGuard],
        component: ReferralRegistrationThankYouComponent,
      },
      {
        path: '',
        canActivate: [NonAuthGuard],
        component: RegisterReferralComponent,
      },
    ],
  },
  {
    path: 'unsubs',
    component: RetrevaMinimalComponent,
    children: [
      {
        path: '',
        component: UnsubsComponent,
      },
    ],
  },
  {
    path: 'contacts',
    loadChildren: () =>
      import('./contacts/contacts.module').then(m => m.ContactsModule),
  },
  {
    path: 'messages',
    loadChildren: () =>
      import('./messages/messages.module').then(m => m.MessagesModule),
  },
  {
    path: 'account',
    component: AuthenticatedComponent,
    loadChildren: () =>
      import('./accounts/accounts.module').then(m => m.AccountsModule),
  },
  {
    path: 'trashes',
    component: AuthenticatedComponent,
    loadChildren: () =>
      import('./trashes/trashes.module').then(m => m.TrashesModule),
  },
  {
    path: 'meetings',
    component: AuthenticatedComponent,
    loadChildren: () =>
      import('./meetings/meetings.module').then(m => m.MeetingsModule),
  },
  {
    path: 'products',
    component: AuthenticatedComponent,
    loadChildren: () =>
      import('./products/products.module').then(m => m.ProductsModule),
  },
  {
    path: 'pipelines',
    component: AuthenticatedComponent,
    loadChildren: () =>
      import('./pipeline-feature/pipeline-feature.module').then(
        m => m.PipelineFeatureModule,
      ),
  },
  {
    path: 'contents',
    loadChildren: () =>
      import('./contents/contents.module').then(m => m.ContentsModule),
  },
  {
    path: 'campaigns',
    loadChildren: () =>
      import('./campaigns/campaigns.module').then(m => m.CampaignsModule),
  },
  {
    path: 'subscriptions',
    loadChildren: () =>
      import('./subscriptions/subscriptions.module').then(
        m => m.SubscriptionsModule,
      ),
  },

  {
    path: 'training_videos',
    component: AuthenticatedComponent,
    loadChildren: () =>
      import('./training-videos/training-videos.module').then(
        m => m.TrainingVideosModule,
      ),
  },

  {
    path: 'lock_domains',
    component: AuthenticatedComponent,
    loadChildren: () =>
      import('./domains/domains.module').then(m => m.DomainsModule),
  },
  {
    path: 'vsm_groups',
    component: AuthenticatedComponent,
    loadChildren: () => import('./vsm/vsm.module').then(m => m.VsmModule),
  },
  {
    path: 'blocked_emails',
    component: AuthenticatedComponent,
    loadChildren: () =>
      import('./blocked-emails/blocked-emails.module').then(
        m => m.BlockedEmailsModule,
      ),
  },
  {
    path: 'bounced_emails',
    component: AuthenticatedComponent,
    loadChildren: () =>
      import('./bounced-emails/bounced-emails.module').then(
        m => m.BouncedEmailsModule,
      ),
  },
  {
    path: 'unknown_emails',
    component: AuthenticatedComponent,
    loadChildren: () =>
      import('./unknown-emails/unknown-emails.module').then(
        m => m.UnknownEmailsModule,
      ),
  },
  {
    path: 'discounts',
    component: AuthenticatedComponent,
    loadChildren: () => import('./discounts/discounts.module').then(m => m.DiscountsModule),
  },
  {
    path: 'reports',
    component: AuthenticatedComponent,
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
  },
  {
    path: 'reports_mail_tracking',
    component: AuthenticatedComponent,
    canActivate: [AuthGuard, AdminGuard],
    loadChildren: () => import('./mail_tracking/mail-tracking.module').then(m => m.MailTrackingModule),
  },
  {
    path: 'class_of_services',
    component: AuthenticatedComponent,
    canActivate: [AuthGuard, AdminGuard],
    loadChildren: () => import('./cos/cos.module').then(m => m.CosModule),
  },
  {
    path: 'integrations',
    component: AuthenticatedComponent,
    canActivate: [AuthGuard, AdminGuard],
    loadChildren: () => import('./integrations/integrations.module').then(m => m.IntegrationsModule),
  },
  {
    path: 'franchisees',
    component: AuthenticatedComponent,
    canActivate: [AuthGuard, FranchiseAccessGuard],
    loadChildren: () => import('./franchisee/franchisee.module').then(m => m.FranchiseeModule),
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
